import * as React from "react";
import styled from "styled-components";
import { NavigationMenu } from "./NavigationMenu";
import logoImg from "../media/img/bbLogoClear.png";

export function NavigationBar() {
  return (
    <NavContainer id="home">
      <BrandLogo loading="lazy" src={logoImg} alt="Company Logo" />
      <NavSection>
        <NavigationMenu />
      </NavSection>
    </NavContainer>
  );
}

const NavContainer = styled.nav`
  position: absolute;
  display: flex;
  width: 100%;
  max-width: 1240px;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  z-index: 100;
  
  @media (max-width: 1260px) {
    max-width: 100%;
    padding: 20px 30px;
  }
  
  @media (max-width: 991px) {
    padding: 15px 20px;
  }
  
  @media (max-width: 768px) {
    padding: 12px 15px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const BrandLogo = styled.img`
  aspect-ratio: 2.4;
  object-fit: contain;
  object-position: center;
  width: 216px;
  align-self: stretch;
  margin: auto 0;
  transition: all 0.3s ease;

  @media (max-width: 991px) {
    width: 180px;
  }
  
  @media (max-width: 768px) {
    width: 150px;
  }
  
  @media (max-width: 510px) {
    width: 120px;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 0 20%;
    padding: 5px;
  }
  
  @media (max-width: 400px) {
    width: 100px;
  }
`;

const NavSection = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 20px;
  margin: auto 0;
  
  @media (max-width: 991px) {
    gap: 15px;
  }
  
  @media (max-width: 768px) {
    gap: 10px;
  }
  
  @media (max-width: 710px) {
    display: flex;
    justify-content: flex-end;
  }
`;
